
import { defineComponent } from 'vue'
import ActionButton from '../Shared/ActionButton.vue'
import UploadImageModal from './UploadImageModal.vue'
import ItemTreeSwitcher from '@/components/IndexTemplates/ItemTreeSwitcher.vue'
import { useFeatureAccess } from '@/composables/useFeatureAccess'

export default defineComponent({
  components: {
    ActionButton,
    UploadImageModal,
    ItemTreeSwitcher
  },
  props: {
    treeView: { type: Boolean, default: false }
  },
  emits: ['itemTreeSwitcherToggled', 'imageUploaded'],
  setup() {
    const { canWrite } = useFeatureAccess('image')

    return {
      modalId: 'upload-image-modal',
      canWrite
    }
  }
})
